import { all, call, fork, put, select, take } from "redux-saga/effects"

import logger from "shared/services/logger"

import {
  PAYMENT_V3_GET_DETAILS,
  PAYMENT_V3_GET_DETAILS_FAILURE,
  PAYMENT_V3_GET_DETAILS_REQUEST,
  PAYMENT_V3_GET_DETAILS_SUCCESS,
  USER_GET_SUCCESS,
} from "../../constants"
import PaymentsAPI from "../../fetch/finance/payments"

function* getPaymentDetails() {
  while (true) {
    yield take([USER_GET_SUCCESS, PAYMENT_V3_GET_DETAILS])
    const { user } = yield select()
    yield put({ type: PAYMENT_V3_GET_DETAILS_REQUEST })
    try {
      const [lastPayment, currentMethod] = yield all([
        call(() => PaymentsAPI.getLastPaymentDetails(user.id)),
        call(() => PaymentsAPI.getCurrentPaymentMethodDetails(user.id)),
      ])

      if (lastPayment.data && currentMethod.data)
        yield put({
          type: PAYMENT_V3_GET_DETAILS_SUCCESS,
          data: {
            last_payment_details: { ...lastPayment.data },
            ...currentMethod.data,
          },
        })
    } catch (error) {
      if (error?.response?.status !== 404) {
        logger(
          "Fetching last payment and the payment method calls failed",
          user.id,
          "PaymentV3:GET details:failed",
          "error",
          error
        )
      }
      yield put({ type: PAYMENT_V3_GET_DETAILS_FAILURE, error })
    }
  }
}

export default function* main() {
  const tasks = yield all([fork(getPaymentDetails)])

  yield all(tasks)
}
